import { v4 as uuidv4 } from 'uuid'
import { genPrompt } from '@/api/prompt'
import { genOssImage } from '@/utils/ossPath'
import { Message } from 'element-ui'
import { getLastUsedBaseUrl, cudaIndexNum } from '@/utils/comfyUiRequest'
import axios from 'axios'
import cuda from '@/utils/checkCuda'
import random from 'random'

import { OSS_ACCESS_KEY_ID, OSS_ACCESS_KEY_SECRET, BAIDU_TRANSLATE_API_KEY } from '@/utils/secretCrypto'
function commonsd1_5(loraname, positive, genParam, progressCallback) {
  return new Promise((resolve, reject) => {
    const imageList = []
    const seed = Math.floor(Math.random() * 100000000000000)
    const filename_1 = `["tmp-comfyui/${String(Date.now()) + String(random.int(1, 99999))}.png"]`
    const filename_2 = `["tmp-comfyui/${String(Date.now()) + String(random.int(1, 99999))}.png"]`
    const filename_3 = `["tmp-comfyui/${String(Date.now()) + String(random.int(1, 99999))}.png"]`
    const filename_4 = `["tmp-comfyui/${String(Date.now()) + String(random.int(1, 99999))}.png"]`
    const promptData = {
      3: {
        inputs: {
          seed: seed,
          steps: 10,
          cfg: 1.3,
          sampler_name: 'lcm',
          scheduler: 'normal',
          denoise: 1,
          model: [
            '11',
            0
          ],
          positive: [
            '13',
            0
          ],
          negative: [
            '12',
            0
          ],
          latent_image: [
            '5',
            0
          ]
        },
        class_type: 'KSampler',
        _meta: {
          title: 'KSampler'
        }
      },
      4: {
        inputs: {
          ckpt_name: 'majicMIX realistic 麦橘写实_v7.safetensors'
        },
        class_type: 'CheckpointLoaderSimple',
        _meta: {
          title: 'Load Checkpoint'
        }
      },
      5: {
        inputs: {
          width: genParam.absWidth,
          height: genParam.absWidth,
          batch_size: 4
        },
        class_type: 'EmptyLatentImage',
        _meta: {
          title: 'Empty Latent Image'
        }
      },
      8: {
        inputs: {
          samples: [
            '3',
            0
          ],
          vae: [
            '4',
            2
          ]
        },
        class_type: 'VAEDecode',
        _meta: {
          title: 'VAE Decode'
        }
      },
      10: {
        inputs: {
          lora_name: 'A001LCM/pytorch_lora_weights.safetensors',
          strength_model: 1.0000000000000000,
          strength_clip: 1.0000000000000000,
          model: [
            '4',
            0
          ],
          clip: [
            '4',
            1
          ]
        },
        class_type: 'LoraLoader',
        _meta: {
          title: 'Load LoRA'
        }
      },
      11: {
        inputs: {
          lora_name: loraname,
          strength_model: genParam.weight,
          strength_clip: 1.0000000000000000,
          model: [
            '10',
            0
          ],
          clip: [
            '10',
            1
          ]
        },
        class_type: 'LoraLoader',
        _meta: {
          title: 'Load LoRA'
        }
      },
      12: {
        inputs: {
          text: 'text, watermark',
          token_normalization: 'none',
          weight_interpretation: 'Stable diffusion',
          clip: [
            '11',
            1
          ]
        },
        class_type: 'AC_Stable Diffusion格式提示词',
        _meta: {
          title: 'AC_Stable Diffusion格式提示词'
        }
      },
      13: {
        inputs: {
          text: [
            '29',
            0
          ],
          token_normalization: 'none',
          weight_interpretation: 'Stable diffusion',
          clip: [
            '11',
            1
          ]
        },
        class_type: 'AC_Stable Diffusion格式提示词',
        _meta: {
          title: 'AC_Stable Diffusion格式提示词'
        }
      },
      21: {
        inputs: {
          model_name: '4x-UltraSharp.pth'
        },
        class_type: 'UpscaleModelLoader',
        _meta: {
          title: 'Load Upscale Model'
        }
      },
      26: {
        inputs: {
          upscale_by: 2.0000000000000000,
          seed: 60958539296379,
          steps: 10,
          cfg: 1.2,
          sampler_name: 'lcm',
          scheduler: 'normal',
          denoise: 0.10000000000000002,
          mode_type: 'Linear',
          tile_width: 512,
          tile_height: 512,
          mask_blur: 8,
          tile_padding: 32,
          seam_fix_mode: 'None',
          seam_fix_denoise: 1,
          seam_fix_width: 64,
          seam_fix_mask_blur: 8,
          seam_fix_padding: 16,
          force_uniform_tiles: true,
          tiled_decode: false,
          image: [
            '8',
            0
          ],
          model: [
            '4',
            0
          ],
          positive: [
            '13',
            0
          ],
          negative: [
            '12',
            0
          ],
          vae: [
            '4',
            2
          ],
          upscale_model: [
            '21',
            0
          ]
        },
        class_type: 'UltimateSDUpscaleCustomSample',
        _meta: {
          title: 'Ultimate SD Upscale (Custom Sample)'
        }
      },
      28: {
        inputs: {
          text: positive,
          translate_from: 'zh',
          translate_to: 'en',
          APIID: '20250612002379955',
          APIKEY: BAIDU_TRANSLATE_API_KEY
        },
        class_type: 'AC_百度翻译',
        _meta: {
          title: 'AC_百度翻译'
        }
      },
      29: {
        inputs: {
          boolean: true,
          on_true: [
            '28',
            0
          ],
          on_false: [
            '30',
            0
          ]
        },
        class_type: 'easy ifElse',
        _meta: {
          title: 'If else'
        }
      },
      30: {
        inputs: {
          text: positive
        },
        class_type: 'Nodepad_啊程记事本',
        _meta: {
          title: 'Nodepad_啊程记事本'
        }
      },
      33: {
        inputs: {
          boolean: false,
          on_true: [
            '26',
            0
          ],
          on_false: [
            '8',
            0
          ]
        },
        class_type: 'easy ifElse',
        _meta: {
          title: 'If else'
        }
      },
      35: {
        inputs: {
          images: [
            '33',
            0
          ]
        },
        class_type: 'ImageListToImageBatch',
        _meta: {
          title: 'Image List to Image Batch'
        }
      },
      47: {
        inputs: {
          index: 0,
          any: [
            '35',
            0
          ]
        },
        class_type: 'easy indexAnything',
        _meta: {
          title: 'Index Any'
        }
      },
      48: {
        inputs: {
          index: 1,
          any: [
            '35',
            0
          ]
        },
        class_type: 'easy indexAnything',
        _meta: {
          title: 'Index Any'
        }
      },
      49: {
        inputs: {
          index: 2,
          any: [
            '35',
            0
          ]
        },
        class_type: 'easy indexAnything',
        _meta: {
          title: 'Index Any'
        }
      },
      50: {
        inputs: {
          index: 3,
          any: [
            '35',
            0
          ]
        },
        class_type: 'easy indexAnything',
        _meta: {
          title: 'Index Any'
        }
      },
      51: {
        inputs: {
          filename: filename_1,
          access_key_id: OSS_ACCESS_KEY_ID,
          access_key_secret: OSS_ACCESS_KEY_SECRET,
          security_token: '',
          bucket_name: 'mj-comfy-ui',
          endpoint: 'oss-cn-shenzhen.aliyuncs.com',
          image: [
            '47',
            0
          ]
        },
        class_type: 'AC_Oss上传图像',
        _meta: {
          title: 'AC_Oss上传图像'
        }
      },
      55: {
        inputs: {
          filename: filename_2,
          access_key_id: OSS_ACCESS_KEY_ID,
          access_key_secret: OSS_ACCESS_KEY_SECRET,
          security_token: '',
          bucket_name: 'mj-comfy-ui',
          endpoint: 'oss-cn-shenzhen.aliyuncs.com',
          image: [
            '48',
            0
          ]
        },
        class_type: 'AC_Oss上传图像',
        _meta: {
          title: 'AC_Oss上传图像'
        }
      },
      56: {
        inputs: {
          filename: filename_3,
          access_key_id: OSS_ACCESS_KEY_ID,
          access_key_secret: OSS_ACCESS_KEY_SECRET,
          security_token: '',
          bucket_name: 'mj-comfy-ui',
          endpoint: 'oss-cn-shenzhen.aliyuncs.com',
          image: [
            '49',
            0
          ]
        },
        class_type: 'AC_Oss上传图像',
        _meta: {
          title: 'AC_Oss上传图像'
        }
      },
      57: {
        inputs: {
          filename: filename_4,
          access_key_id: OSS_ACCESS_KEY_ID,
          access_key_secret: OSS_ACCESS_KEY_SECRET,
          security_token: '',
          bucket_name: 'mj-comfy-ui',
          endpoint: 'oss-cn-shenzhen.aliyuncs.com',
          image: [
            '50',
            0
          ]
        },
        class_type: 'AC_Oss上传图像',
        _meta: {
          title: 'AC_Oss上传图像'
        }
      }
    }
    const clientId = uuidv4()
    const data = {
      prompt: promptData,
      client_id: clientId
    }
    // 发送 Prompt 请求
    const sendPromptRequest = async () => {
      try {
        console.log('get prompt response', data)
        return genPrompt(data)
      } catch (error) {
        console.error('发送作图请求失败：', error)
      }
    }

    const fetchImageFilename = async (promptId) => {
      try {
        // 直接使用该实例请求历史记录
        const historyRequest = axios.create({
          baseURL: getLastUsedBaseUrl(),
          timeout: 5000,
          headers: {
            'Content-Type': 'application/json'
          }
        })

        const response = await historyRequest.get(`/history/${promptId}`)
        const promptInfo = response.data[promptId]
        const promptIndex = 2 // prompt信息的下标
        if (promptInfo.status.status_str === 'success') {
          const img1 = JSON.parse(promptInfo.prompt[promptIndex][51].inputs.filename)
          const img2 = JSON.parse(promptInfo.prompt[promptIndex][55].inputs.filename)
          const img3 = JSON.parse(promptInfo.prompt[promptIndex][56].inputs.filename)
          const img4 = JSON.parse(promptInfo.prompt[promptIndex][57].inputs.filename)
          const temp = [img1[0], img2[0], img3[0], img4[0]]
          temp.forEach(async (item) => {
            const imagepath = genOssImage(item)
            // await this.getTaskEnd(imagepath, this.taskLogId)
            imageList.push(imagepath)
          })
        } else {
          console.error('获取历史记录失败，状态码：', response.status)
        }
        return imageList
      } catch (error) {
        console.error('获取图像文件名失败：', error)
      }
    }

    const listenToProgress = (promptId) => {
      const ws = new WebSocket(`${getLastUsedBaseUrl()}/ws?clientId=${clientId}`)
      const wsTimeout = setTimeout(() => {
        Message.warning('网络连接超时,请重新尝试!')
        ws.close()
      }, 2000)

      ws.onopen = () => {
        console.log('提交服务器开始生成...')
        clearTimeout(wsTimeout)
      }
      ws.onmessage = async (event) => {
        clearTimeout(wsTimeout)
        const data = event.data
        if (typeof data === 'string') {
          try {
            const msg = JSON.parse(event.data)
            if (msg.type === 'executing') {
              const data = msg.data
              if (data.node === null && data.prompt_id === promptId) {
                ws.close()
                const images = await fetchImageFilename(promptId)
                // 返回对象
                const obj = {
                  images: images,
                  status: false
                }
                resolve(obj)
              }
            } else if (msg.type === 'progress') {
              const value = msg.data.value
              const max = msg.data.max
              const current = (value / max * 100).toFixed(2)
              if (progressCallback && typeof progressCallback === 'function') {
                progressCallback(current)
              }
            }
          } catch (error) {
            console.log('获取结果失败，请重试')
          }
        }
      }
      ws.onerror = (error) => {
        reject(error)
      }
      ws.onclose = async () => {
        try {
          const index = cudaIndexNum()
          await cuda.changeCudaCurrentStatus(index, 'leisure')
        } catch (error) { console.log(error) }
      }
    }

    (async () => {
      const result = await sendPromptRequest()
      if (result && result.prompt_id) {
        listenToProgress(result.prompt_id)
      }
    })()
  })
}

export {
  commonsd1_5
}
